import { JSX } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

interface ErrorPageProps {
  traceId?: string;
}

function Forbidden(): JSX.Element {
  return errorPageTemplate("Forbidden", "Access is denied due to insufficient privileges", { iconDescription: "Lock", iconName: QesIcons.LockV1 });
}

function NotFound(): JSX.Element {
  return errorPageTemplate("404 Not Found", "Sorry! That web page no longer practices at this location.", { iconDescription: "Search", iconName: QesIcons.SearchSm });
}

function ServerError(props: ErrorPageProps): JSX.Element {
  return errorPageTemplate("Sorry!", "Something went wrong on our end.", { iconDescription: "Alert", iconName: QesIcons.AlertTriangle }, props.traceId);
}

function Unauthorized(): JSX.Element {
  return errorPageTemplate("Unauthorized", "Access is denied due to invalid credentials");
}

function HomepageError(): JSX.Element {
  return errorPageTemplate("Sorry!", "There was an error applying your filters. They have been removed. Please refresh your page to return to the Home screen.", { iconDescription: "Alert", iconName: QesIcons.AlertTriangle });
}

function errorPageTemplate(title: string, description: string, mainIcon?: { iconDescription: string, iconName: string}, traceId?: string): JSX.Element {
  return (
    <div className="error-page">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {mainIcon ? <span className="main-icon"><QesIcon iconName={mainIcon.iconName} description={mainIcon.iconDescription} width="80"/></span> : null}
            <span>
              <p className="error-type">{title}</p>
              <p className="error-description">
                <span><QesIcon iconName={QesIcons.ChevronRightDouble} isDecorative={true} width="24"/></span>{description}
                {!!traceId && <><br />
                  <span><QesIcon iconName={QesIcons.ChevronRightDouble} isDecorative={true} width="24" /></span>For help, please contact <a href="mailto:consulting@questanalytics.com">consulting@questanalytics.com</a>.<br />
                  <span><QesIcon iconName={QesIcons.ChevronRightDouble} isDecorative={true} width="24" /></span>Server-side error tracking ID: {traceId}
                </>}
              </p>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export {
  HomepageError,
  Forbidden,
  NotFound,
  ServerError,
  Unauthorized,
};
